import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShellAndTubeHeatExchanger2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60.0 60.0",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 30,
		cy: 30,
		rx: 30,
		ry: 30,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 7.5 10.0 L 45.0 10.0 L 15.0 30.0 L 45.0 50.0 L 7.5 50.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgShellAndTubeHeatExchanger2;
